import React from 'react';
import styles from "./slide-button.module.scss"
import { useSwiper } from 'swiper/react';

export default function SlideButton({next, setSlideNumber, slideNumber}: {next?: boolean, setSlideNumber: (arg: number) => void, slideNumber: number}) {
  const swiper = useSwiper();

  return (
    <button className={`${styles.slideButton} ${next ? styles.next : styles.prev}`} onClick={() => {
      if (next) {
        swiper.slideNext()
        setSlideNumber(slideNumber + 1)
      } else {
        swiper.slidePrev()
        setSlideNumber(slideNumber - 1)
      }
    }}></button>
  );
}